module.exports = __webpack_public_path__ + "264254ce8921ba732c0879ff6ad3d8ca.svg";